export default "__VITE_ASSET__DgaZNHCh__"